import React, { Component } from 'react';
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
          <div className="row section-head">
            <div className="ten columns">
              <p className="lead">
              Currently I am looking for the a position such as programmer, game developer, software tester or any IT related fields, feel free to contact me for any job opportunity.
              </p>
            </div>
          </div>
        </section>
        );
  }
}